export const isNetworkError = (err: any): boolean =>
  err?.code === 'ERR_NETWORK' || !err?.response || err?.response?.status === 0;

export const getErrorMessageKey = (err: any, fallbackKey: string): string =>
  isNetworkError(err) ? 'ERROR_GENERIC' : err?.response?.data?.message || fallbackKey;
